import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { removeInvalidItems } from "@tKgpco/Handlers/Cart/InvalidItemsService";
import { MarkAsReadFn } from "@tKgpco/Services/ReadAllMsgService";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

export type InvalidItemsParameters = {
    cartLineIds: string[];
} & HasOnSuccess &
    HasOnError;
type HandlerType = ApiHandler<InvalidItemsParameters>;

export const PopulateApiParameter: HandlerType = props => {
    const { cartLineIds } = props.parameter;
    props.apiParameter = {
        cartLineIds,
    };
};

export const removeIvalidItemsFn: HandlerType = async props => {
    try {
        const apiResult = await removeInvalidItems(props.apiParameter.cartLineIds);
        if (apiResult) {
            props.parameter.onSuccess?.(apiResult);
        }
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    if (props.parameter?.onSuccess) {
        markSkipOnCompleteIfOnSuccessIsSet?.(props);
        props.parameter.onSuccess();

        props.dispatch(loadCurrentCart({ getPromotions: true }));
    }
};
export const ExecuteOnError: HandlerType = props => {
    markSkipOnCompleteIfOnErrorIsSet?.(props);
};

export const chain = [PopulateApiParameter, removeIvalidItemsFn, ExecuteOnSuccess, ExecuteOnError];

const removeInvalidItemsHandler = createHandlerChainRunner(chain, "removeInvalidItemsHandler");
export default removeInvalidItemsHandler;
